export { ContrareciboList } from "./list/list";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/index.tsx